module.exports = __webpack_public_path__ + "img/play_EN.280b2673.png";